/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        statusContainer: {
            height: theme.spacing(4),
            display: "flex",
            alignItems: "center",
            width: 'fit-content',
            padding: theme.spacing(1.25),
            ...theme.custom.elements.status.containerStyles
        },
        statusLabel: {
            margin: '0 auto',
        },
        dot: {
            height: 8,
            width: 8,
            borderRadius: "50%",
            display: "inline-block",
            marginRight: theme.spacing(1.25)
        },
        statusText: {
            ...theme.custom.elements.status.textStyle
        },
        activeDot: {
            ...theme.custom.elements.status.activeDotStyle
        },
        stoppedDot: {
            ...theme.custom.elements.status.stoppedDotStyle
        },
        pendingDot: {
            ...theme.custom.elements.status.pendingDotStyle
        },
        draftedDot: {
            ...theme.custom.elements.status.draftedDotStyle
        }
    })
);
